/**
 * Created by danielr on 6/16/15.
 */

define(function (require) {
    "use strict";

    var RevisionedModel = require("models/RevisionedModel");
    var OAuth2ImplicitModel = {};

    var KEYS = {
        AUTH_END_POINT: "authorizationEndpoint",
        JWT_PUBLIC_KEY: "jwtPublicKey",
        JS_METHOD_NAME: "jsMethodName",
        JS_CONTEXT: "jsContext",
        ACR_VALUES: "acrValues"
    };

    var CONST = {
        URL_NOT_VALID_ERR_MSG: "LEManager.manager.dataSources.authentication.server.url.not.valid",
        HTTPS_MANDATORY_URL_ERROR_MSG: "LEManager.manager.dataSources.authentication.server.https.mandatory"
    };

    LE.module('LEManager', function (LEManager, LE, Backbone, Marionette, $, _) {
        OAuth2ImplicitModel = RevisionedModel.extend({
            defaults: {
                "authorizationEndpoint": "",
                "jwtPublicKey": "",
                "jsMethodName": "",
                "jsContext": ""
            },
            name: "OAuth2ImplicitModel",

            initialize: function (options) {
                this.isNewAuthType = true;
                RevisionedModel.prototype.initialize.call(this, options);
            },

            validation: {
                "authorizationEndpoint": {
                    fn: function () {
                        var url = this.getAuthorizationEndpoint();
                        if(!_.isEmpty(url)){
                            //if url is not empty validate it
                            return this._getUrlValidationErrorMessage(url);
                        }
                    }
                },
                "jwtPublicKey": {
                    required: true,
                    msg:"LEManager.manager.dataSources.authentication.server.oauth.jwtPublicKey.required"
                }
            },

            /* private getter setter */
            getAuthorizationEndpoint: function(){
                return this.get(KEYS.AUTH_END_POINT);
            },
            setAuthorizationEndpoint: function(value){
                this.set(KEYS.AUTH_END_POINT, value.trim());
            },
            getAcrValues: function(){
                return this.get(KEYS.ACR_VALUES);
            },
            getJwtPublicKey: function(){
                return this.get(KEYS.JWT_PUBLIC_KEY);
            },
            setJwtPublicKey: function(value){
                this.set(KEYS.JWT_PUBLIC_KEY, value.trim());
            },

            getJsMethodName: function(){
                return this.get(KEYS.JS_METHOD_NAME);
            },
            setJsMethodName: function(value){
                this.set(KEYS.JS_METHOD_NAME, value.trim());
            },

            getJsContext: function(){
                return this.get(KEYS.JS_CONTEXT);
            },
            setJsContext: function(value){
                this.set(KEYS.JS_CONTEXT, value.trim());
            },

            _allFieldsEmpty: function(){
                return _.isEmpty(this.getAuthorizationEndpoint()) &&
                    _.isEmpty(this.getJwtPublicKey()) &&
                    _.isEmpty(this.getJsMethodName()) &&
                    _.isEmpty(this.getJsContext());
            },

            _getUrlValidationErrorMessage:function(url){
                url = url.trim();

                if(_.isNull(url.match(Backbone.Validation.patterns.httpsOnly))){
                    return CONST.HTTPS_MANDATORY_URL_ERROR_MSG;
                }
                if(_.isNull(url.match(Backbone.Validation.patterns.fullUrl))){
                    return CONST.URL_NOT_VALID_ERR_MSG;
                }
            },

            setIsNewAuth: function(value){
                this.isNewAuthType = value;
            },

            isDeleteAction: function(){
                return false; //Delete action is temporarly disabled until new PROD and UX final decision
                //return this._allFieldsEmpty() && !this.isNewAuthType;
            }

        });
    });



    OAuth2ImplicitModel.KEYS = KEYS;
    return OAuth2ImplicitModel;
});

